import axios from 'axios';

export class PmsAPI {
    static sale = class {
        static index = (periodType, date, roomCod = null) => {
            const params = { type: periodType, date: date };
            if (roomCod) params.room_cod = roomCod;
            return axios.get(`/pms/sale/`, { params })
        }

        // 銷售統計 (依訂單日期)
        static insdate = class {
            // GET /pms/sale/insdate/stat/?type=day&room_cod=DT
            static stat = (periodType, roomCod = null) => {
                const params = { type: periodType };
                if (roomCod) params.room_cod = roomCod;
                return axios.get(`/pms/sale/insdate/stat/`, { params })
            };
            // GET /pms/sale/insdate/?type=day&date=2022/03/07&room_cod=ST
            static index = (periodType, date, roomCod = null) => {
                const params = { type: periodType, date: date };
                if (roomCod) params.room_cod = roomCod;
                return axios.get(`/pms/sale/insdate/`, { params })
            }
        }

        // 銷售統計 (依入住日期)
        static cidate = class {
            // GET /pms/sale/cidate/stat/?type=day&room_cod=DT
            static stat = (periodType, roomCod = null) => {
                const params = { type: periodType };
                if (roomCod) params.room_cod = roomCod;
                return axios.get(`/pms/sale/cidate/stat/`, { params })
            };
            // GET /pms/sale/cidate/?type=day&date=2022/04/28&room_cod=ST
            static index = (periodType, date, roomCod = null) => {
                const params = { type: periodType, date: date };
                if (roomCod) params.room_cod = roomCod;
                return axios.get(`/pms/sale/cidate/`, { params })
            }
        }
    }

    // 住房統計 (RVUSE_DT)
    static houserate = class {
        // 住房清單
        // GET /pms/houserate/stat/?type=day&room_cod=DT
        static stat = (periodType, roomCod = null) => {
            const params = { type: periodType };
            if (roomCod) params.room_cod = roomCod;
            return axios.get(`/pms/houserate/stat/`, { params })
        };

        // 住房明細
        // GET /pms/houserate/?type=day&date=2022/04/21&room_cod=ST
        static index = (periodType, date, roomCod = null) => {
            const params = { type: periodType, date: date };
            if (roomCod) params.room_cod = roomCod;
            return axios.get(`/pms/houserate/`, { params })
        }

        // 空房明細
        // GET /pms/houserate/remain/?type=day&date=2022/04/21&room_cod=ST
        static remain = (periodType, date, roomCod = null) => {
            const params = { type: periodType, date: date };
            if (roomCod) params.room_cod = roomCod;
            return axios.get(`/pms/houserate/remain/`, { params })
        }

        // 住房率超過 5 成
        // /pms/houserate/overpercentage/
        static overpercentage = () => {
            return axios.get(`/pms/houserate/overpercentage/`)
        }
        // 銷售明細 /pms/sale/?type=day&date=2022/04/21
    }

    // 房型庫存查詢
    static inventory = class {
        // GET /pms/inventory/?from=2026/08/27&to=2026/09/25
        // 一律取全部房型 —— 業務多半先鎖定日期再橫向比較各房型,不需要房型篩選。
        // (後端仍支援選用的 room_cod 參數,目前前端未使用)
        static index = (from, to) => {
            return axios.get(`/pms/inventory/`, { params: { from, to } })
        }
    }

    // OTA 曝光分析 —— 未售的房裡有多少 OTA 碰不到
    static exposure = class {
        // GET /pms/exposure/stat?from=2026/08/01&to=2026/08/31
        static stat = (from, to) => {
            return axios.get(`/pms/exposure/stat`, { params: { from, to } })
        }

        // GET /pms/exposure/schedule?months=6
        // 固定從今天起算，與 stat 的期間選擇無關 —— 這是排程缺口的預警
        static schedule = (months = 6) => {
            return axios.get(`/pms/exposure/schedule`, { params: { months } })
        }
    }

    // 房型統計 (N2400_ROOM_MN)
    static room = class {
        // GET /pms/room/stat/?type=day
        static stat = (periodType) => {
            return axios.get(`/pms/room/stat/`, {
                params: {
                    type: periodType
                }
            })
        };
        static statByNo = (periodType, date) => {
            return axios.get(`/pms/room/stat/by-no`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        };

        // 明細
        // GET /pms/room/?type=day&date=2022/02/07
        static index = (periodType = null, date = null) => {
            const params = {};
            if (periodType) params.type = periodType;
            if (date) params.date = date;
            return axios.get(`/pms/room/`, { params })
        }
        
        // 獲取所有房型代碼 (不帶條件)
        // GET /pms/room/
        static getAllRoomCodes = () => {
            return axios.get(`/pms/room/`)
        }
        static show = (roomCod, periodType, date) => {
            return axios.get(`/pms/room/${roomCod}`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        }
    }

    // 住客統計 (GHIST)
    static guest = class {
        // GET /pms/guest/stat/?type=day
        static stat = (periodType) => {
            return axios.get(`/pms/guest/stat/`, {
                params: {
                    type: periodType
                }
            })
        };
        static statByRegion = (periodType, date) => {
            return axios.get(`/pms/guest/stat/by-region`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        };
        static statByGender = (periodType, date) => {
            return axios.get(`/pms/guest/stat/by-gender`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        };
        static statByAge = (periodType, date) => {
            return axios.get(`/pms/guest/stat/by-age`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        }

        // 明細
        // GET /pms/guest/?type=day&date=2022/02/08
        static index = (periodType, date) => {
            return axios.get(`/pms/guest/`, {
                params: {
                    type: periodType,
                    date: date
                }
            })
        }
    }

    // 回頭客分析
    static repeatGuests = class {
        // GET /pms/repeat-guests?unit=month|year (回訪走 OTA 的比例、佣金與直訂流失；整頁一次取回)
        static index = (unit) => {
            return axios.get(`/pms/repeat-guests`, { params: { unit } });
        };
    }

    // 通路統計 (訂房來源 ORDER_MN.CUST_NAM)
    static channel = class {
        static index = (query, page, pageSize) => {
            return axios.get(`/pms/channel/`, {
                params: {
                    page: page || 1,
                    count: pageSize || 30,
                    ...query
                },
            })
        };

        // GET /pms/channel/stat?from=..&to=..&basis=stay|book
        static stat = (from, to, basis = "stay") => {
            return axios.get(`/pms/channel/stat`, { params: { from, to, basis } });
        };

        // GET /pms/channel/detail?source=直客&type=day|month|year&basis=stay|book[&from=&to=]
        // 本期下鑽才帶 from/to (合計要與排行表那一列對得上);不帶時後端回退長跨度。
        // 只帶單邊等同沒帶,故兩者皆備才送。
        static detail = (source, type, basis = "stay", from = null, to = null) => {
            const params = { source, type, basis };
            if (from && to) {
                params.from = from;
                params.to = to;
            }
            return axios.get(`/pms/channel/detail`, { params });
        };
    }

    // 營運儀表板彙總 (依 from/to 區間，一次回通路/房型/取消/部門營收)
    static ops = class {
        // GET /pms/ops/breakdown?from=2026/07/01&to=2026/07/16
        static breakdown = (from, to) => {
            return axios.get(`/pms/ops/breakdown`, { params: { from, to } });
        };
        // GET /pms/ops/kpi?from=..&to=.. (任意區間彙總，供本期與去年同期 STLY 對比)
        static kpi = (from, to) => {
            return axios.get(`/pms/ops/kpi`, { params: { from, to } });
        };
        // GET /pms/ops/series?from=..&to=..&unit=day|month (任意區間逐桶趨勢，供去年同期 STLY 逐桶對照)
        static series = (from, to, unit) => {
            return axios.get(`/pms/ops/series`, { params: { from, to, unit } });
        };
        // GET /pms/ops/pace?from=..&to=..&asof=..&unit=day|week|month
        // (逐桶在手：合計 + 團體/散客分層，as-of 還原與分桶口徑皆同 pace-band)
        static pace = (from, to, asof, unit) => {
            return axios.get(`/pms/ops/pace`, { params: { from, to, asof, unit } });
        };
        // GET /pms/ops/pace-band?from=..&to=..&asof=..&years=&unit=day|week|month (訂房曲線正常帶：過去 N 年同 lead 的 P25–P75)
        static paceBand = (from, to, asof, years, unit) => {
            return axios.get(`/pms/ops/pace-band`, { params: { from, to, asof, years, unit } });
        };
        // GET /pms/ops/pace-velocity?from=..&to=..&days= (訂房增速：近 N 個訂房日、落在窗口的每日淨訂房 新增−取消)
        static paceVelocity = (from, to, days) => {
            return axios.get(`/pms/ops/pace-velocity`, { params: { from, to, days } });
        };
        // GET /pms/ops/pace-pickup?from=..&to=..&days= (依未來住用日的近期淨 pickup 新增−取消，與前瞻同 x 軸對照)
        static pacePickup = (from, to, days) => {
            return axios.get(`/pms/ops/pace-pickup`, { params: { from, to, days } });
        };
        // GET /pms/ops/pace-pickup-room?from=..&to=..&days= (各房型的近期淨 pickup 售罄動能，供房型維度看仍在進單/已停)
        static pacePickupByRoom = (from, to, days) => {
            return axios.get(`/pms/ops/pace-pickup-room`, { params: { from, to, days } });
        };
        // GET /pms/ops/pickup-orders?stay_from=..&stay_to=..&book_from=..&book_to= (訂房增速某根柱底下的實際訂單明細)
        static pickupOrders = (stayFrom, stayTo, bookFrom, bookTo) => {
            return axios.get(`/pms/ops/pickup-orders`, { params: { stay_from: stayFrom, stay_to: stayTo, book_from: bookFrom, book_to: bookTo } });
        };
        // GET /pms/ops/pickup-orders?basis=otb&stay_from=..&stay_to=.. (該住用區間目前在手的訂單，訂房曲線抽屜用)
        static otbOrders = (stayFrom, stayTo, roomCod = null) => {
            return axios.get(`/pms/ops/pickup-orders`, { params: { basis: 'otb', stay_from: stayFrom, stay_to: stayTo, room_cod: roomCod || undefined } });
        };
        // GET /pms/ops/pace-curve?from=..&to=..&asof=..&years= (單日或期間的訂房曲線：今年+過去 N 年各提前天數的在手率)
        // roomCod 給定時只看該房型：在手與分母 (該房型房數) 同時切換
        static paceCurve = (from, to, asof, years, roomCod = null) => {
            return axios.get(`/pms/ops/pace-curve`, { params: { from, to, asof, years, room_cod: roomCod || undefined } });
        };
        // GET /pms/ops/pricing-actions?from=..&to=..&years=5 (逐日在手率與剩餘進帳率百分位，供定價建議)
        static pricingActions = (from, to, years = 5) => {
            return axios.get(`/pms/ops/pricing-actions`, { params: { from, to, years } });
        };
        // GET /pms/ops/feedback-summary?gran=week&from=..&to=.. (住客回饋的期別 AI 摘要，純讀已排程算好的結果)
        static feedbackSummary = (gran, from, to) => {
            return axios.get(`/pms/ops/feedback-summary`, { params: { gran, from, to } });
        };
        // GET /pms/ops/feedback-items?from=..&to=..&source=&page=&per_page=&ids= (當期回饋明細，無論有無摘要都可用)
        // ids 是摘要卡「依據的回饋」的下鑽：只取那幾則，後端此時忽略 from/to。
        static feedbackItems = (from, to, source, page, perPage, ids) => {
            return axios.get(`/pms/ops/feedback-items`, {
                params: { from, to, source, page, per_page: perPage, ids: ids && ids.length ? ids.join(",") : undefined },
            });
        };
        // GET /pms/ops/guest-lookup?feedback_id=&name=&phone=&room=&date= (回饋明細點姓名查住客)
        // 帶 feedback_id 時後端從問卷解析條件；另外帶的欄位蓋過問卷，空字串代表清掉不查。
        static guestLookup = (params) => {
            return axios.get(`/pms/ops/guest-lookup`, { params });
        };
        // GET /pms/ops/guest-visits/{key} (某位住客的歷次住房，重複建檔的同一人已合併)
        static guestVisits = (key) => {
            return axios.get(`/pms/ops/guest-visits/${encodeURIComponent(key)}`);
        };
        // GET /pms/ops/feedback-needs?from=..&to=..&prev_from=..&prev_to=.. (住客需求排行)
        // 去年同期由儀表板傳入，沿用它自己的日曆身分對齊規則。
        static feedbackNeeds = (from, to, prevFrom, prevTo) => {
            return axios.get(`/pms/ops/feedback-needs`, {
                params: { from, to, prev_from: prevFrom, prev_to: prevTo },
            });
        };
    }

    // 銷售方案統計
    static promotion = class {
        static index = (query, page, pageSize) => {
            return axios.get(`/pms/promotion/`, {
                params: {
                    page: page || 1,
                    count: pageSize || 30,
                    ...query
                },
            })
        };

        // GET /pms/promotion/stat?from=..&to=..&basis=stay|book
        // (排行 + 上期環比;上期由後端以前一段等長區間推算)
        static stat = (from, to, basis = "stay") => {
            return axios.get(`/pms/promotion/stat`, { params: { from, to, basis } });
        };

        // GET /pms/promotion/detail?rate_cod=web01&type=day|month|year&basis=stay|book[&from=&to=]
        // (下鑽:本期才帶 from/to,合計要與排行表那一列對得上;不帶時後端回退長跨度。
        //  只帶單邊等同沒帶,故兩者皆備才送)
        static detail = (rateCod, type, basis = "stay", from = null, to = null) => {
            const params = { rate_cod: rateCod, type, basis };
            if (from && to) {
                params.from = from;
                params.to = to;
            }
            return axios.get(`/pms/promotion/detail`, { params });
        };
    }

    // 通路佣金設定 (MySQL channel_commissions 的 CRUD)
    static commission = class {
        static index = () => axios.get(`/channel-commissions`);
        static create = (data) => axios.post(`/channel-commissions`, data);
        static update = (id, data) => axios.put(`/channel-commissions/${id}`, data);
        static remove = (id) => axios.delete(`/channel-commissions/${id}`);
    }

    // 年度平旺假日規劃 (Oracle 歷史實績 + holidays 規則)
    static rateCalendar = class {
        // GET /pms/rate-calendar?year=2027&base_years[]=..&peak_holiday_run=..&..
        static index = (params) => {
            return axios.get(`/pms/rate-calendar`, { params });
        };
        // GET /pms/rate-calendar/pace?dates[]=..&leads[]=.. (住房率撞天花板時才查)
        static pace = (dates, leads = [30, 60, 90]) => {
            return axios.get(`/pms/rate-calendar/pace`, { params: { dates, leads } });
        };
        // POST /pms/rate-calendar/export —— 人工調整存在瀏覽器，後端不知道，
        // 只能把最終級別送上去讓它排版著色。回應是 xlsx 二進位，要 blob。
        static exportXlsx = (year, levels) => {
            return axios.post(`/pms/rate-calendar/export`, { year, levels }, { responseType: 'blob' });
        };
    };

}
